import PropTypes from 'prop-types';
import Container from '@/components/Container';
import TrainerDesign from '@/domain/Trainer/TrainerDesign';

const defaultProps = {};

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function TrainerSingleBaseLayout({ children }) {
  return (
    <div className="bg-gradient-to-b from-white to-gray-100 py-10 lg:py-20 relative">
      <Container>{children}</Container>
      <TrainerDesign />
    </div>
  );
}

TrainerSingleBaseLayout.defaultProps = defaultProps;
TrainerSingleBaseLayout.propTypes = propTypes;
